export const hireTeamImages = {
  hero: {
    android:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/android-developer-hero.webp",
    angularJS:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/angularjs-hero.webp",
    aspNet:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/asp.net-developer-hero.webp",
    automationTestEngineer:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/automationtest-engineer-hero.webp",
    awsCloud:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/awscloud-developer-hero.webp",
    azureCloud:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/azurecloud-developer-hero.webp",
    blockchain:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/blockchain-developer-hero.webp",
    devops:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/devops-engineer-hero.webp",
    flutter:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/flutter-developer-hero.webp",
    fullstackJava:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/fullstack-java-developer-hero.webp",
    fullstackPython:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/fullstack-python-developer-hero.webp",
    gcpCloud:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/gcpcloud-developer-hero.webp",
    golang:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/golang-hero.webp",
    ionic:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/ionic-developer-hero.webp",
    ios: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/ios-developer-hero.webp",
    machineLearning:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/machinelearning-engineer-hero.webp",
    manualQA:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/manualqa-engineer-hero.webp",
    mernStack:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/mern-stack-developer-hero.webp",
    meanStack:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/mean-stack-developer-hero.webp",
    moodle:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/moodle-developer-hero.webp",
    nodejs:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/nodejs-hero.webp",
    php: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/php-developer-hero.webp",
    powerbi:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/powerbi-developer-hero.webp",
    reactJS:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/reactjs-hero.webp",
    reactNative:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/reactnative-developer-hero.webp",
    rpa: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/rpa-developer-hero.webp",
    uiux: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/uiux-developer-hero.webp",
    vuejs:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/vuejs-hero.webp",
    wordpress:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/wordpress-developer-hero.webp",
    xamarin:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/xamarin-developer-hero.webp",
    securityTestEngineer:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/banners/security-test-engineer-hero.webp",
  },
  technologyImg: {
    android:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/android-list.webp",
    angularJS:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/angular-list.webp",
    aspNet:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/aspnet-list.webp",
    awsCloud:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/aws-list.webp",
    azureCloud:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/azure-list.webp",
    blockchain:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/blockchain-list.webp",
    devops:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/devops-list.webp",
    flutter:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/flutter-list.webp",
    gcpCloud:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/gcp-list.webp",
    golang:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/golang-list.webp",
    ionic:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/ionic-list.webp",
    ios: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/ios-list.webp",
    fullstackJava:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/java-list.webp",
    meanStack:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/meanstack-list.webp",
    mernStack:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/mernstack-list.webp",
    machineLearning:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/ml-list.webp",
    moodle:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/moodle-list.webp",
    nodejs:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/nodejs-list.webp",
    php: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/php-list.webp",
    powerbi:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/power-bi-list.webp",
    fullstackPython:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/python-list.webp",
    reactJS:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/reactjs-list.webp",
    reactNative:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/react-native-list.webp",
    rpa: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/rpa-list.webp",
    securityTestEngineer:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/securitytest-list.webp",
    softwareTestEngineer:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/software-testing-list.webp",
    uiux: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/uiux-list.webp",
    vuejs:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/vuejs-list.webp",
    wordpress:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/wordpress-list.webp",
    xamarin:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/software-list/xamarin-list.webp",
  },
};
